// extracted by mini-css-extract-plugin
export default {"item":"item--PQZ32","icon":"icon--w5sVm","wrapper":"wrapper--zFxg5","disabled":"disabled--drb4d","border":"border--pP7v0","archive":"archive--qZdaV disabled--drb4d"};